import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import Sections from '~/constants/sections';
import UpArrow from '~/icons/UpArrow';
import { getHasOwnerReviews, getShouldShowPriceDetails } from '~/selectors';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  DesktopPageNavigationWrapper,
  DesktopStickyPageNavigationInnerWrapper,
  DesktopStickyPageNavigationWrapper,
  NavigationButton,
  NavigationColumnOne,
  NavigationColumnTwo,
  NavigationTab,
  NavigationTabIndicator,
  NavigationText
} from './DesktopPageNavigation.styles';
import { useCurrentSection, useSticky } from './hooks';

const topOffset = 137; // It's maaaaagiiiic....

const DesktopPageNavigation = () => {
  const currentSection = useCurrentSection(topOffset);
  const shouldShowPriceDetails = useSelector(getShouldShowPriceDetails);
  const hasOwnerReviews = useSelector(getHasOwnerReviews);
  const { isSticky, updateStickyState } = useSticky();

  return (
    <>
      <DesktopPageNavigationWrapper>
        <Waypoint
          topOffset={78}
          onEnter={updateStickyState}
          onLeave={updateStickyState}
        />
      </DesktopPageNavigationWrapper>
      <DesktopStickyPageNavigationWrapper
        data-qa="desktop-sticky-page-navigation-wrapper"
        id="desktop-navigation"
      >
        <DesktopStickyPageNavigationInnerWrapper
          className={classnames({ 'box-shadow': isSticky })}
        >
          <NavigationColumnOne>
            {isSticky && (
              <NavigationButton
                href={`#${Sections.Root}`}
                data-analytics-id="Nav - Top"
              >
                <UpArrow />
                <NavigationText className="mx-8" data-cv-test="vdp-sub-nav">
                  Top
                </NavigationText>
              </NavigationButton>
            )}
          </NavigationColumnOne>
          <NavigationColumnTwo>
            <NavigationTab
              href={`#${Sections.VehicleDetails}`}
              data-analytics-id="Nav - Vehicle Details"
            >
              <NavigationText data-cv-test="vdp-sub-nav">
                Vehicle Details
              </NavigationText>
              {currentSection === Sections.VehicleDetails && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
            {shouldShowPriceDetails && (
              <NavigationTab
                href={`#${Sections.PriceDetails}`}
                data-analytics-id="Nav - Price Details"
              >
                <NavigationText data-cv-test="vdp-sub-nav">
                  Price Details
                </NavigationText>
                {currentSection === Sections.PriceDetails && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            {hasOwnerReviews && (
              <NavigationTab
                href={`#${Sections.OwnerReviews}`}
                data-analytics-id="Nav - Owner Reviews"
              >
                <NavigationText data-cv-test="vdp-sub-nav">
                  Owner Reviews
                </NavigationText>
                {currentSection === Sections.OwnerReviews && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            <NavigationTab
              href={`#${Sections.Inspection150Point}`}
              data-analytics-id="Nav - 150 Point Inspection"
            >
              <NavigationText data-cv-test="vdp-sub-nav">
                Inspection
              </NavigationText>
              {currentSection === Sections.Inspection150Point && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
          </NavigationColumnTwo>
        </DesktopStickyPageNavigationInnerWrapper>
      </DesktopStickyPageNavigationWrapper>
    </>
  );
};

export default withErrorBoundary(DesktopPageNavigation);
